export default __webpack_public_path__ + "static/media/cif-il.9cbaf348.svg";